import { render } from "./ArrowExpandVertical.vue?vue&type=template&id=7cae9d66"
import script from "./ArrowExpandVertical.vue?vue&type=script&lang=js"
export * from "./ArrowExpandVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/ArrowExpandVertical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7cae9d66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7cae9d66', __exports__)) {
    api.reload('7cae9d66', __exports__)
  }
  
  module.hot.accept("./ArrowExpandVertical.vue?vue&type=template&id=7cae9d66", () => {
    api.rerender('7cae9d66', render)
  })

}


export default __exports__